import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import FormFields from "../../components/common/FormFields";
import { PARKING } from "../../utils/constants";
import { IFormSection, TFormHookParams } from "../../types/common";
import {
  createColumn,
  createEditAction,
  getForm,
  getRegister,
  getResultOptions,
} from "../../utils/helpers";
import { URL_PARKINGS } from "../../utils/urls";
import useGet from "../common/useGet";
import {
  API_EXPORT_PARKING_YARD,
  API_PARKINGS,
  API_STREETS,
} from "../../utils/apis";

export const useParkings = () => {
  const tableColumns = () => [
    createColumn("district_name", true, "District Name"),
    createColumn("name", true, "Parking Yard Name"),
    createColumn("street_name", true),
    createColumn("capacity", false),
    createColumn("longitude", false),
    createColumn("latitude", false),
    createColumn("actions", false),
  ];

  const tableData = (data: any) => {
    if (!data) return [];

    return data.map((item: any) => {
      return {
        ...item,
        parking_yard_name: item.name,
        street_name: item.street,
        actions: (
          <FormActions
            actions={[
              createEditAction(URL_PARKINGS, item?.id),
              // createDeleteAction(URL_PARKINGS, item?.id),
            ]}
          />
        ),
      };
    });
  };

  const formRoute = getForm(URL_PARKINGS);
  const activityFilter = "parking_yards";

  const exportData = {
    api: API_EXPORT_PARKING_YARD,
    fileName: `parking_yard_${new Date().toISOString().split("T")[0]}.csv`,
  };

  return {
    exportData,
    tableData,
    tableColumns,
    formRoute,
    activityFilter,
  };
};

export const useParkingForm = ({ updateFormValues }: TFormHookParams = {}) => {
  const {
    loadData: loadStreetData,
    loading: loadingStreets,
    data: streetsData,
  } = useGet();

  const { loadData, loading, data } = useGet();

  useEffect(() => {
    loadData({ api: API_PARKINGS });
  }, []);

  useEffect(() => {
    loadStreetData({ api: API_STREETS });
  }, []);

  useEffect(() => {
    if (updateFormValues) {
      updateFormValues({
        street_type: PARKING,
      });
    }
  }, [updateFormValues]);

  const sections: IFormSection[] = [
    {
      title: "Parking Details",
      fields: [
        {
          field_name: "name",
          label: "Parking Yard Name",
          type: "text",
          props: { required: true },
        },
        {
          field_name: "street",
          label: "Street",
          type: "select",
          props: { required: true },
          options_data: getResultOptions(streetsData, "name"),
          loading: loadingStreets,
        },

        {
          field_name: "capacity",
          type: "number",
          label: "Capacity",
          props: { required: true, showCommas: false },
        },
      ],
    },
    {
      title: "Location Details",
      fields: [
        // ...location?.fields(true),
        {
          field_name: "coordinates",
          type: "location",
          props: { wide: true },
        },
      ],
    },
  ];

  const getConfigOptions = () => {
    return {
      streets: getResultOptions(streetsData, "name"),
    };
  };

  const options = {
    ...getConfigOptions(),
  };

  const title = "Parking Yard Management";
  const redirect = getRegister(URL_PARKINGS);

  return {
    sections,
    title,
    redirect,
    options,
    loading,
    data,
    streetsData,
    loadingStreets,
  };
};

export const ParkingForm = ({
  form,
  error,
  updateFormValue,
  onChange,
}: any) => {
  const { sections } = useParkingForm({
    form,
    updateFormValues: updateFormValue,
  });

  return (
    <div>
      {sections.map((section: IFormSection, index: number) => (
        <div key={index}>
          <h3>{section.title}</h3>
          <FormFields
            form={form}
            error={error}
            updateFormValue={updateFormValue}
            onChange={onChange}
            fields={section.fields}
          />
        </div>
      ))}
    </div>
  );
};
